import * as httpHelper from 'service/api/httpHelper.js';//网络助手
import storageUtils from 'utils/js/storageUtils.js';//
import * as utils from 'utils/js/mixin.js';//
import store from '../../../store/store.js'
import { httpUrl } from 'service/api/httpUrl.js'

//广告管理：主要是banner这些

/** 获取广告位列表 */
export function getSiteBill(params) {
  return httpHelper.get('getSiteBill',params);
}

/** 添加修改广告位 */
export function addSite(params) {
  return httpHelper.post('addSite',params);
}

/** 删除广告位 */
export function deleteSite(params) {
  return httpHelper.post('deleteSite',params);
}

/** 获取广告列表 */
export function getBannerBill(params) {
  return httpHelper.get('getBannerBill',params);
}

/** 添加修改广告 */
export function addBanner(params) {
  return httpHelper.post('addBanner',params);
}

/** 上架下架广告 */
export function upperLower(params) {
  return httpHelper.post('upperLower',params);
}

/** 删除广告 */
export function deleteBanner(params) {
  return httpHelper.post('deleteBanner',params);
}

/** 增加点击率 */
export function addClickRate(params) {
  return httpHelper.post('addClickRate',params,false);
}

// /**
//  * 权限接口
//  */
// export function saveVerifyJudges() {
//   return new Promise((resolve, reject) => {
//     httpHelper.get("verifyJudges",{}).then((res)=>{
//       if(res.data){
//         // storageUtils.saveVerifyJudges(res.data.isJudges);
//         store.state.user.isJudges=res.data.isJudges;
//         store.state.user.admin=res.data.admin;
//       }else{
//         // storageUtils.saveVerifyJudges(false);
//         store.state.user.isJudges=false;
//         store.state.user.admin=-1;
//       }
//       resolve(res);
//     }).catch((earr)=>{
//         // storageUtils.saveVerifyJudges(false);
//         store.state.user.isJudges=false;
//         store.state.user.admin=-1;
//         console.log(earr);
//         reject(earr);
//     });
//   })
// }

// /**
//  * 获取用户未读消息数
//  * 
//  */
// export function getUnReadMsgCount() {
//   return new Promise((resolve, reject) => {
//     httpHelper.get("getUnReadMsgCount",{}).then((res)=>{
//       if(res.data){
//         store.state.user.userUnReadMsgCount=res.data;
//         resolve(res);
//       }else{
//         store.state.user.userUnReadMsgCount=0;
//         reject(res);
//       }
//     }).catch((earr)=>{
//       store.state.user.userUnReadMsgCount=0;
//       reject(earr);
//     });
//   })
// }


// ====================================自定义=======================================
/** 加载广告数据(banner) */
export function loadAdvertisingData(params) {
  return new Promise((resolve, reject) => {
    getSiteBill(params).then((res)=>{
        if(!utils.isArrayEmpty(res.data)){
            let siteid=res.data[0].siteid;
            getBannerBill({siteid:siteid,status:1}).then((res)=>{
              resolve(res);
            }).catch((earr)=>{
              reject(earr);
            });
        }else{
          reject("暂无数据");
        }
    }).catch((earr)=>{
      reject(earr);
    });
  })
}
// ====================================自定义=======================================